import React from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Modal from '../../Modal';
import { useDashboard } from '../contexts/DashboardContext';
import { WidgetTemplateCard } from './WidgetTemplateCard';
import { WidgetTemplate } from '../types';
import { WIDGET_TEMPLATES } from '../mockData';
import styles from './WidgetLibrary.module.scss';

interface WidgetLibraryProps {
  isOpen: boolean;
  onClose: () => void;
}

export const WidgetLibrary: React.FC<WidgetLibraryProps> = ({
  isOpen,
  onClose,
}) => {
  const { t } = useTranslation();
  const { activeDashboard, addWidget } = useDashboard();

  const handleSelectTemplate = (template: WidgetTemplate) => {
    if (!activeDashboard) return;

    addWidget({
      dashboardId: activeDashboard.id,
      title: template.label,
      chartType: template.type,
      query: { sql: template.sampleQuery },
      config: template.defaultConfig,
    });

    toast.success(t('Widget added') as string);
    onClose();
  };

  return (
    <Modal
      isVisible={isOpen}
      title={t('Widget Library')}
      onClose={onClose}
      className={styles.modal}
      footer={null}
      content={
        <div className={styles.grid}>
          {WIDGET_TEMPLATES.map((template) => (
            <WidgetTemplateCard
              key={template.type}
              template={template}
              onSelect={handleSelectTemplate}
            />
          ))}
        </div>
      }
    />
  );
};
